import {
  LoginFormBase,
  type LoginFormBaseProps,
  type LoginFormData,
} from "@core/features/auth";
import { Form } from "@themes/pollinator/ui/Form";
import { FormField } from "@themes/pollinator/ui/FormField";
import { AuthButtons } from "@themes/pollinator/ui/AuthButtons";
import { AuthLoginAdditionalContent } from "../../components/AuthLoginAdditionalContent";

export type { LoginFormData };

export type Props = Omit<
  LoginFormBaseProps,
  "renderForm" | "renderActions" | "renderAdditionalContent"
>;

/**
 * Login form component that renders email/password fields with submit actions.
 * This is a presentational component - business logic should be in the container.
 */
export function LoginForm({
  form,
  onLogin,
  onLoginWithGoogle,
  hideSignupLink,
}: Props) {
  return (
    <LoginFormBase
      form={form}
      onLogin={onLogin}
      onLoginWithGoogle={onLoginWithGoogle}
      hideSignupLink={hideSignupLink}
      className="flex flex-col gap-8"
      renderForm={({ form }) => (
        <Form form={form} className="w-full" innerClassName="justify-center">
          <FormField
            name="email"
            label="Email"
            component="Input"
            placeholder="Enter your email"
            autoComplete="username"
            required
          />
          <FormField
            name="password"
            label="Password"
            component="Input"
            type="password"
            placeholder="Enter your password"
            autoComplete="current-password"
            required
          />
        </Form>
      )}
      renderActions={({
        isSubmitting,
        isValid,
        onLogin,
        onLoginWithGoogle,
      }) => (
        <AuthButtons
          isSubmitting={isSubmitting}
          isLoading={false}
          isValid={isValid}
          onSubmit={onLogin}
          onSubmitWithGoogle={onLoginWithGoogle}
          submitLabel="Sign in"
          googleLabel="Sign in with Google"
          isWithBorder={false}
          isWithPadding={false}
          className="w-full justify-center items-center"
          signupButtonClassName="w-full"
          googleButtonClassName="w-full"
        />
      )}
      renderAdditionalContent={({ hideSignupLink }) => (
        <AuthLoginAdditionalContent hideSignupLink={hideSignupLink} />
      )}
    />
  );
}

export default LoginForm;

